import React from "react";
import ModalPortal from "../potal";

import {
  Background,
  StyledConfirmModal,
  StyledAfterConfirmModal,
  StyledAccused,
} from "./style";

// 수정/삭제 여부 확인메세지
export const DeleteModal = ({
  query,
  notice,
  onClickCancel,
  onClickConfirm,
}) => {
  return (
    <ModalPortal>
      <Background>
        <StyledConfirmModal>
          <h2>{query}</h2>
          <div className="notice">{notice}</div>
          <div className="button">
            <button onClick={onClickCancel}>취소</button>
            <button
              onClick={() => {
                onClickConfirm();
              }}
            >
              삭제
            </button>
          </div>
        </StyledConfirmModal>
      </Background>
    </ModalPortal>
  );
};

// 삭제버튼 누르면 나오는 메세지
export const ConfirmMsg = ({ afterConfirm }) => {
  return (
    <ModalPortal>
      <Background>
        <StyledAfterConfirmModal>{afterConfirm}</StyledAfterConfirmModal>
      </Background>
    </ModalPortal>
  );
};

// 신고접수 하면 뜨는 메세지
export const Accused = () => {
  return (
    <ModalPortal>
      <Background>
        <StyledAccused>
          <h2>신고가 접수되었습니다.</h2>
          <p>
            관리자의 확인 후, 커뮤니티 규칙에
            <br />
            부적절한 내용이 확인되면 조치하겠습니다
          </p>
        </StyledAccused>
      </Background>
    </ModalPortal>
  );
};

// 확인/취소 메세지
export const ConfirmModal = ({
  query,
  notice,
  onClickCancel,
  onClickConfirm,
}) => {
  return (
    <ModalPortal>
      <Background>
        <StyledConfirmModal>
          <h2>{query}</h2>
          <div className="notice">{notice}</div>
          <div className="button">
            <button onClick={onClickCancel}>취소</button>
            <button
              onClick={() => {
                onClickConfirm();
              }}
            >
              확인
            </button>
          </div>
        </StyledConfirmModal>
      </Background>
    </ModalPortal>
  );
};

// 알림 메세지 (확인버튼만)
export const AlertModal = ({ notice, onClickConfirm }) => {
  return (
    <ModalPortal>
      <Background>
        <StyledConfirmModal>
          <div className="notice" style={{ marginTop: "32px" }}>
            {notice}
          </div>
          <div className="button">
            <button
              onClick={() => {
                onClickConfirm();
              }}
            >
              확인
            </button>
          </div>
        </StyledConfirmModal>
      </Background>
    </ModalPortal>
  );
};
